<div class="mc" [class.pantalla-completa]="vistaPrevia || idEditando !== null">

  <!-- ==================== Editor anidado ====================
       La captura vive aquí y no en las tarjetas: el backend reemplaza el árbol
       completo al guardar, así que hay que mandarlo entero. -->
  <div class="mc-editor" *ngIf="idEditando !== null">
    <app-modal-matriz-riesgos-ia
      [idActivo]="idEditando ? idEditando : null"
      [idMatriz]="idMatriz"
      [embebido]="true"
      (cerrado)="cerrarEditor($event)">
    </app-modal-matriz-riesgos-ia>
  </div>

  <!-- ==================== Vista de tarjetas ==================== -->
  <ng-container *ngIf="!vistaPrevia && idEditando === null">
   <div class="mc-panel">

    <div class="mc-barra">
      <div>
        <strong>Activos</strong>
        <span class="mc-hint">
          Cada activo con su valoración, el riesgo <b>antes y después</b> del plan,
          las amenazas que lo afectan y sus cortes de monitoreo.
        </span>
      </div>
      <div class="mc-acciones">
        <!-- Quien no edita ve por que: si no, parece que la pantalla se rompio. -->
        <span class="mc-solo-lectura" *ngIf="!puedeEditar"
              matTooltip="La matriz es un documento certificable: sólo el perfil de edición puede cambiarla.">
          Sólo lectura
        </span>
        <button *ngIf="puedeEditar" type="button" class="mc-btn-pri" (click)="agregarActivo()"
                [disabled]="hayEdicionAbierta"
                [title]="hayEdicionAbierta ? avisoBloqueo() : ''">+ Agregar activo</button>
        <button type="button" class="mc-btn-sec" (click)="alternarVista()"
                matTooltip="La hoja tal como se ve en el Excel oficial, a pantalla completa. Solo lectura.">
          Ver formato FOS-005
        </button>
        <button *ngIf="puedeEditar" type="button" class="mc-btn-sec" (click)="alternarPapelera()"
                matTooltip="Activos eliminados que todavía se pueden restaurar, con su folio y sus cortes.">
          {{ papeleraAbierta ? 'Ocultar eliminados' : 'Eliminados' }}
        </button>
      </div>
    </div>

    <!-- ===== Papelera: lo eliminado que todavía se puede resucitar ===== -->
    <div class="mc-papelera" *ngIf="papeleraAbierta">
      <div class="mc-papelera-cab">
        <strong>Activos eliminados</strong>
        <span class="mc-hint">
          Vuelven con su folio, sus amenazas, sus cortes y su bitácora. Como regresan con
          sus mismos identificadores, sus evidencias quedan ligadas solas.
        </span>
      </div>

      <div class="mc-vacio-mini" *ngIf="cargandoPapelera">Consultando…</div>

      <ng-container *ngIf="!cargandoPapelera">
        <div class="mc-vacio-mini" *ngIf="papelera.length === 0">
          No hay activos eliminados. Aquí aparecen en cuanto se borre alguno.
        </div>

        <div class="mc-bit mc-resp" *ngFor="let r of papelera">
          <div class="mc-bit-cuerpo-txt">
            <div class="mc-bit-cab">
              <strong>{{ r.referencia || 'Sin folio' }}</strong>
              <span class="mc-bit-quien" *ngIf="r.usuarioNombre">Lo eliminó {{ r.usuarioNombre }}</span>
              <span class="mc-bit-fecha">{{ r.fecha | fechaBitacora }}</span>
            </div>
            <div class="mc-bit-valores" *ngIf="r.resumen">
              <span class="mc-bit-antes">{{ r.resumen }}</span>
            </div>
          </div>
          <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini"
                  (click)="restaurarEliminado(r)"
                  [disabled]="restaurandoPapelera.has(r.idRespaldo!)">
            {{ restaurandoPapelera.has(r.idRespaldo!) ? 'Restaurando…' : 'Restaurar' }}
          </button>
        </div>
      </ng-container>
    </div>

    <!-- Filtro por nivel de riesgo y búsqueda -->
    <div class="mc-filtros" *ngIf="!cargando && activos.length > 0">
      <label class="mc-buscar">
        <span class="mc-buscar-icono">🔍</span>
        <input class="mc-buscar-campo" [(ngModel)]="busqueda"
               placeholder="Buscar por folio, nombre o tipo" />
        <button type="button" class="mc-buscar-x" *ngIf="busqueda"
                (click)="limpiarBusqueda()" title="Limpiar">✕</button>
      </label>

      <span class="mc-filtros-et">Riesgo</span>
      <button type="button" class="mc-chip-f" [class.activo]="filtro === 'Todas'"
              (click)="filtro = 'Todas'">
        Todos <span class="mc-n">{{ activos.length }}</span>
      </button>
      <button type="button" *ngFor="let b of bandas" class="mc-chip-f"
              [ngClass]="claseRiesgo(b)" [class.activo]="filtro === b" (click)="filtro = b">
        {{ b }} <span class="mc-n">{{ conteo(b) }}</span>
      </button>
    </div>

    <div class="mc-cargando" *ngIf="cargando">Cargando…</div>

    <div class="mc-vacio" *ngIf="!cargando && activos.length === 0">
      Sin activos en la matriz.
      <button *ngIf="puedeEditar" type="button" class="mc-btn-sec" (click)="agregarActivo()">+ Agregar el primero</button>
    </div>
    <div class="mc-vacio" *ngIf="!cargando && activos.length > 0 && filtrados.length === 0">
      <span *ngIf="busqueda">Ningún activo coincide con «{{ busqueda }}»</span>
      <span *ngIf="!busqueda">Ningún activo con riesgo {{ filtro }}.</span>
      <button type="button" class="mc-btn-sec" *ngIf="busqueda" (click)="limpiarBusqueda()">
        Limpiar búsqueda
      </button>
    </div>

    <!-- ===== Una tarjeta por activo ===== -->
    <div class="mc-card" *ngFor="let a of filtrados"
         [id]="'act-' + a.idMatrizActivo"
         [class.enfocado]="enfocado === a.idMatrizActivo"
         [class.edicion]="enEdicion(a)"
         [ngClass]="claseRiesgo(a.clasificacionActual)"
         [class.inactivo]="a.estatus !== 'ACTIVO'" [hidden]="cargando">

      <div class="mc-card-cab">
        <button type="button" class="mc-caret-btn" (click)="alternarTarjeta(a)"
                [title]="expandido(a) ? 'Contraer' : 'Ver detalle'">
          {{ expandido(a) ? '▾' : '▸' }}
        </button>
        <span class="mc-folio">{{ a.consecutivo }}</span>
        <span class="mc-nombre">{{ a.nombreActivo }}</span>
        <span class="mc-tag" *ngIf="a.inventarioConsecutivo">{{ a.inventarioConsecutivo }}</span>
        <!-- De dónde vino: la solicitud de IA con que se autorizó. Entró a
             la matriz sola, al aprobarse, sin valoración ni amenazas. -->
        <span class="mc-tag" *ngIf="a.solicitudFolio"
              [title]="'Entró a la matriz al autorizarse la solicitud ' + a.solicitudFolio + ' en Solicitudes IA.'">
          Viene de la solicitud {{ a.solicitudFolio }}
        </span>
        <span class="mc-tag" *ngIf="a.tipoActivo">{{ a.tipoActivo }}</span>
        <span class="mc-pill-baja" *ngIf="a.estatus !== 'ACTIVO'">Dado de baja</span>
        <!-- Aviso de monitoreo (29/09/2026): se ve sin desplegar nada. -->
        <ng-container *ngIf="a.estatus === 'ACTIVO' && proximo(a) as p">
          <span class="mc-pill aviso-vencido" *ngIf="p.estado === 'VENCIDO'" [title]="p.detalle">{{ p.texto }}</span>
          <span class="mc-pill aviso-pronto" *ngIf="p.estado === 'POR_VENCER'" [title]="p.detalle">{{ p.texto }}</span>
        </ng-container>
        <!-- Contraída, el encabezado tiene que bastar para saber cómo va. -->
        <span class="mc-cab-sev" *ngIf="!expandido(a)">
          <span class="mc-n-mini" [ngClass]="claseRiesgo(a.clasificacionActual)">
            {{ a.riesgoActual ?? '—' }}
          </span>
          <span class="mc-cab-flecha">&rarr;</span>
          <span class="mc-n-mini" [ngClass]="claseRiesgo(a.clasificacionResidual)">
            {{ a.riesgoResidual ?? '—' }}
          </span>
        </span>
        <span class="mc-espacio"></span>
        <ng-container *ngIf="!enEdicion(a)">
          <!-- El botón de Expediente se quitó de aquí a petición del usuario.
               El componente y su llamada siguen en el .ts: para devolverlo
               basta con reponer este botón, no hay que rehacer nada.
          <button type="button" class="mc-btn-sec mini" (click)="abrirExpediente(a)"
                  matTooltip="Todo lo relacionado con este activo: inventario, monitoreos, incidencias y riesgos de proceso. Evidencia de trazabilidad.">
            Expediente
          </button>
          -->
          <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="editarDatos(a)"
                  [disabled]="bloqueado(a)"
                  [title]="bloqueado(a) ? avisoBloqueo() : ''">Editar</button>
          <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="editar(a)"
                  [disabled]="bloqueado(a)"
                  [title]="bloqueado(a) ? avisoBloqueo() : ''"
                  matTooltip="Abre el editor completo para capturar amenazas, vulnerabilidades y acciones">
            Editar amenazas
          </button>
          <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="alternarEstatus(a)"
                  [disabled]="bloqueado(a)"
                  [title]="bloqueado(a) ? avisoBloqueo() : ''">
            {{ a.estatus === 'ACTIVO' ? 'Dar de baja' : 'Reactivar' }}
          </button>
          <button *ngIf="puedeEditar" type="button" class="mc-btn-rojo mini" (click)="eliminar(a)"
                  [disabled]="bloqueado(a)"
                  [title]="bloqueado(a) ? avisoBloqueo() : ''">Eliminar</button>
        </ng-container>
        <ng-container *ngIf="enEdicion(a)">
          <button *ngIf="puedeEditar" type="button" class="mc-btn-pri" (click)="guardarDatos(a)"
                  [disabled]="guardandoActivo.has(a.idMatrizActivo!)">
            {{ guardandoActivo.has(a.idMatrizActivo!) ? 'Guardando…' : 'Guardar' }}
          </button>
          <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="cancelarEdicionDatos(a)"
                  [disabled]="guardandoActivo.has(a.idMatrizActivo!)">
            Cancelar
          </button>
        </ng-container>
      </div>

      <!-- ===== Corrección de los datos del activo, en la propia tarjeta ===== -->
      <div class="mc-form" *ngIf="enEdicion(a)">
        <label class="mc-campo doble">
          <span class="mc-et">Nombre del activo <b class="oblig">*</b></span>
          <input class="i" [maxlength]="lim.activo.nombreActivo" [(ngModel)]="borrador(a).nombreActivo" />
        </label>
        <label class="mc-campo">
          <span class="mc-et">Tipo de activo</span>
          <select class="i" [(ngModel)]="borrador(a).tipoActivo">
            <option value="Software">Software</option>
            <option value="Hardware">Hardware</option>
          </select>
        </label>
        <label class="mc-campo">
          <span class="mc-et">Fecha de identificación</span>
          <input type="date" class="i" [(ngModel)]="borrador(a).fechaIdentificacion" />
        </label>

        <label class="mc-campo">
          <span class="mc-et">Confidencialidad</span>
          <select class="i" [(ngModel)]="borrador(a).valConfidencialidad">
            <option [ngValue]="null"></option>
            <option *ngFor="let v of valoracionPor('CONFIDENCIALIDAD')" [ngValue]="v.nivel"
                    [title]="v.descripcion">{{ v.nivel }} — {{ v.etiqueta }}</option>
          </select>
        </label>
        <label class="mc-campo">
          <span class="mc-et">Integridad</span>
          <select class="i" [(ngModel)]="borrador(a).valIntegridad">
            <option [ngValue]="null"></option>
            <option *ngFor="let v of valoracionPor('INTEGRIDAD')" [ngValue]="v.nivel"
                    [title]="v.descripcion">{{ v.nivel }} — {{ v.etiqueta }}</option>
          </select>
        </label>
        <label class="mc-campo">
          <span class="mc-et">Disponibilidad</span>
          <select class="i" [(ngModel)]="borrador(a).valDisponibilidad">
            <option [ngValue]="null"></option>
            <option *ngFor="let v of valoracionPor('DISPONIBILIDAD')" [ngValue]="v.nivel"
                    [title]="v.descripcion">{{ v.nivel }} — {{ v.etiqueta }}</option>
          </select>
        </label>

        <label class="mc-campo doble">
          <span class="mc-et">Activos dependientes</span>
          <textarea class="i ta" rows="2" [maxlength]="lim.activo.activosDependientes" [(ngModel)]="borrador(a).activosDependientes"></textarea>
        </label>
        <label class="mc-campo doble">
          <span class="mc-et">Justificación de la valoración</span>
          <textarea class="i ta" rows="3" [maxlength]="lim.activo.justificacionValoracion" [(ngModel)]="borrador(a).justificacionValoracion"></textarea>
        </label>

        <div class="mc-campo doble">
          <div class="mc-form-nota">
            El riesgo se recalcula solo al guardar. Las amenazas de este activo
            no se tocan desde aquí: para eso está <b>Editar amenazas</b>.
          </div>
        </div>
      </div>

      <!-- Riesgo antes y después del plan -->
      <div class="mc-eval" *ngIf="!enEdicion(a) && expandido(a)">
        <div class="mc-eval-caja">
          <div class="mc-eval-tit">Riesgo actual</div>
          <div class="mc-eval-fila">
            <span class="mc-sev" [ngClass]="claseRiesgo(a.clasificacionActual)">
              <span class="mc-sev-num">{{ a.riesgoActual ?? '—' }}</span>
              <span class="mc-sev-de">de 11</span>
            </span>
            <span class="mc-eval-txt">
              <span class="mc-eval-banda">{{ a.clasificacionActual || 'Por calcular' }}</span>
              <span class="mc-eval-formula" *ngIf="a.valorActivo != null">
                Valor {{ a.valorActivo }} · amenaza {{ a.nivelAmenaza }} ·
                vulnerabilidad {{ a.nivelVulnerabilidad }}
              </span>
            </span>
          </div>
        </div>

        <div class="mc-flecha">
          <span class="mc-flecha-simbolo">&rarr;</span>
          <span class="mc-mejora baja" *ngIf="(mejora(a) ?? 0) > 0">bajó {{ mejora(a) }}</span>
          <span class="mc-mejora igual" *ngIf="mejora(a) === 0">sin cambio</span>
          <span class="mc-mejora sube" *ngIf="(mejora(a) ?? 0) < 0">subió {{ -mejora(a)! }}</span>
        </div>

        <div class="mc-eval-caja azul">
          <div class="mc-eval-tit">Riesgo residual</div>
          <div class="mc-eval-fila">
            <span class="mc-sev" [ngClass]="claseRiesgo(a.clasificacionResidual)">
              <span class="mc-sev-num">{{ a.riesgoResidual ?? '—' }}</span>
              <span class="mc-sev-de">de 11</span>
            </span>
            <span class="mc-eval-txt">
              <span class="mc-eval-banda">{{ a.clasificacionResidual || 'Por reevaluar' }}</span>
              <span class="mc-eval-formula" *ngIf="a.nivelAmenazaTrasPlan != null">
                Valor {{ a.valorActivo }} · amenaza {{ a.nivelAmenazaTrasPlan }} ·
                vulnerabilidad {{ a.nivelVulnerabilidadTrasPlan }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- Valoración del activo -->
      <div class="mc-valoracion" *ngIf="!enEdicion(a) && expandido(a)">
        <div class="mc-val-caja"
             [matTooltip]="etiquetaValoracion('CONFIDENCIALIDAD', a.valConfidencialidad)">
          <span class="mc-val-et">Confidencialidad</span>
          <span class="mc-val-num">{{ a.valConfidencialidad ?? '—' }}</span>
        </div>
        <div class="mc-val-caja"
             [matTooltip]="etiquetaValoracion('INTEGRIDAD', a.valIntegridad)">
          <span class="mc-val-et">Integridad</span>
          <span class="mc-val-num">{{ a.valIntegridad ?? '—' }}</span>
        </div>
        <div class="mc-val-caja"
             [matTooltip]="etiquetaValoracion('DISPONIBILIDAD', a.valDisponibilidad)">
          <span class="mc-val-et">Disponibilidad</span>
          <span class="mc-val-num">{{ a.valDisponibilidad ?? '—' }}</span>
        </div>
        <div class="mc-val-caja total"
             matTooltip="El valor del activo es el mayor de las tres dimensiones.">
          <span class="mc-val-et">Valor del activo</span>
          <span class="mc-val-num">{{ a.valorActivo ?? '—' }}</span>
        </div>
      </div>

      <div class="mc-campos" *ngIf="!enEdicion(a) && expandido(a)">
        <div class="mc-campo doble" *ngIf="a.activosDependientes">
          <div class="mc-et">Activos dependientes</div>
          <div class="mc-val">{{ a.activosDependientes }}</div>
        </div>
        <div class="mc-campo doble" *ngIf="a.justificacionValoracion">
          <div class="mc-et">Justificación de la valoración</div>
          <div class="mc-val">{{ a.justificacionValoracion }}</div>
        </div>
        <div class="mc-campo">
          <div class="mc-et" title="El día que se identificó el activo y se valoró por primera vez. Viene del FOS-005.">Fecha de identificación</div>
          <div class="mc-val">{{ (a.fechaIdentificacion | date: 'dd/MM/yyyy') || '—' }}</div>
        </div>
        <div class="mc-campo" *ngIf="a.estatus === 'ACTIVO' && proximo(a) as p">
          <div class="mc-et" [title]="'Los activos se monitorean cada ' + mesesActivos + ' meses, contados desde su último corte.'">
            Próximo monitoreo
          </div>
          <div class="mc-val mc-proximo" [ngClass]="'es-' + p.estado">{{ p.detalle }}</div>
        </div>
        <!-- OCULTO A PETICIÓN DEL USUARIO (21/08/2026): "Se comprueba".
             Confundía, porque no es cada cuánto se revisa de verdad: es el
             PLAZO MÁXIMO que marca el formato para la banda de riesgo en la
             que cayó el activo (Alto -> semestral, Muy Alto -> trimestral),
             y aquí el monitoreo se hace cada cuatro meses, más seguido.
             El dato se sigue calculando y guardando; solo no se pinta.
             Para devolverlo, quitar estos comentarios. -->
        <!--
        <div class="mc-campo">
          <div class="mc-et" title="Plazo máximo que marca el formato para volver a comprobar este activo, según su banda de riesgo. Revisarlo antes cumple igual.">Se comprueba</div>
          <div class="mc-val">{{ a.periodicidadMaxima || '—' }}</div>
        </div>
        -->
      </div>

      <!-- ===== Amenazas ===== -->
      <div class="mc-arbol" *ngIf="expandido(a)">
        <button type="button" class="mc-toggle" (click)="alternarArbol(a)">
          <span class="mc-caret">{{ abiertos.has(a.idMatrizActivo!) ? '▾' : '▸' }}</span>
          Amenazas
          <span class="mc-n">
            {{ cuenta(a).amenazas }} amenazas · {{ cuenta(a).vulnerabilidades }} vulnerabilidades
            · {{ cuenta(a).acciones }} acciones
          </span>
          <span class="mc-pill" *ngIf="cuenta(a).amenazas === 0">sin capturar</span>
        </button>

        <div class="mc-ramas" *ngIf="abiertos.has(a.idMatrizActivo!)">
          <div class="mc-vacio-mini" *ngIf="cuenta(a).amenazas === 0">
            Este activo no tiene amenazas capturadas, por eso su riesgo no se puede calcular.
            Captúralas con <b>Editar</b>.
          </div>

          <div class="mc-amenaza" *ngFor="let am of a.amenazas">
            <div class="mc-amenaza-cab">
              <span class="mc-punto"></span>
              <strong>{{ am.nombreAmenaza }}</strong>
              <span class="mc-prob">
                {{ etiquetaProb('AMENAZA', am.probActual) }}
                <span class="mc-prob-flecha">&rarr;</span>
                {{ etiquetaProb('AMENAZA', am.probTrasPlan) }}
              </span>
            </div>

            <div class="mc-vuln" *ngFor="let vu of am.vulnerabilidades">
              <div class="mc-vuln-cab">
                <span class="mc-et-mini">Vulnerabilidad</span>
                {{ vu.nombreVulnerabilidad }}
                <span class="mc-prob">
                  {{ etiquetaProb('VULNERABILIDAD', vu.probActual) }}
                  <span class="mc-prob-flecha">&rarr;</span>
                  {{ etiquetaProb('VULNERABILIDAD', vu.probTrasPlan) }}
                </span>
              </div>

              <div class="mc-accion" *ngFor="let ac of vu.acciones">
                <div class="mc-accion-txt">{{ ac.descripcion }}</div>
                <div class="mc-accion-pie">
                  <span class="mc-pill" *ngIf="ac.estado">{{ ac.estado }}</span>
                  <span *ngIf="ac.responsable">{{ ac.responsable }}</span>
                  <span *ngIf="ac.prioridad">Prioridad {{ ac.prioridad }}</span>
                  <span *ngIf="ac.fechaEjecucion">
                    Para el {{ ac.fechaEjecucion | date: 'dd/MM/yyyy' }}
                  </span>
                </div>
                <div class="mc-accion-recursos" *ngIf="ac.recursos">
                  <span class="mc-et-mini">Recursos</span> {{ ac.recursos }}
                </div>
              </div>

              <div class="mc-vacio-mini" *ngIf="!vu.acciones || vu.acciones.length === 0">
                Sin acciones para esta vulnerabilidad.
              </div>
            </div>

            <div class="mc-vacio-mini" *ngIf="!am.vulnerabilidades || am.vulnerabilidades.length === 0">
              Sin vulnerabilidades para esta amenaza.
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Monitoreo ===== -->
      <div class="mc-cortes" *ngIf="expandido(a)">
        <button type="button" class="mc-toggle" (click)="alternarCortes(a)">
          <span class="mc-caret">{{ cortesAbiertos.has(a.idMatrizActivo!) ? '▾' : '▸' }}</span>
          Monitoreo
          <span class="mc-n">{{ a.seguimientos?.length || 0 }} cortes</span>
          <span class="mc-pill" *ngIf="pendientes(a) > 0">{{ pendientes(a) }} sin resultado</span>
        </button>

        <div class="mc-linea" *ngIf="cortesAbiertos.has(a.idMatrizActivo!)"
             [class.sin-cortes]="!a.seguimientos || a.seguimientos.length === 0">
          <!-- Alta de corte: arriba, porque el corte nuevo es el más reciente
               y la línea va del más reciente al más antiguo (29/09/2026). -->
          <div class="mc-corte alta" *ngIf="enEdicion(a) && nuevoCorte[a.idMatrizActivo!]">
            <span class="mc-punto-c nuevo"></span>
            <div class="mc-corte-cuerpo">
              <div class="mc-corte-form">
                <input type="date" class="i fecha" aria-label="Fecha del corte"
                       [min]="minNuevoCorte(a)"
                       [(ngModel)]="nuevoCorte[a.idMatrizActivo!].fechaMonitoreo" />
                <input class="i" aria-label="Qué se encontró en este corte (si no se revisó, escribe NA y la razón)"
                       placeholder="Qué se encontró en este corte (si no se revisó, escribe NA y la razón)"
                       [maxlength]="lim.corte.resultado" [(ngModel)]="nuevoCorte[a.idMatrizActivo!].resultado" />
                <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="agregarCorte(a)"
                        [disabled]="guardandoCorte.has(a.idMatrizActivo!)">
                  {{ guardandoCorte.has(a.idMatrizActivo!) ? 'Guardando…' : '+ Agregar corte' }}
                </button>
              </div>
              <div class="mc-corte-ayuda">
                Se guarda al momento, aparte del activo. La periodicidad la exige la
                clasificación del riesgo.
              </div>
            </div>
          </div>
          <div class="mc-corte" *ngFor="let s of cortesRecientes(a); let primero = first"
               [class.ultimo]="primero"
               [class.pendiente]="esPendiente(s.resultado) && !editandoCorte(s)"
               [class.editando]="editandoCorte(s)">
            <span class="mc-punto-c"></span>

            <!-- ----- Lectura ----- -->
            <div class="mc-corte-cuerpo" *ngIf="!editandoCorte(s)">
              <div class="mc-corte-cab">
                <strong>{{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}</strong>
                <span class="mc-pill ultimo" *ngIf="primero">Último monitoreo</span>
                <span class="mc-corte-quien" *ngIf="s.usuarioNombre">· {{ s.usuarioNombre }}</span>
                <span class="mc-pill falta" *ngIf="esPendiente(s.resultado)">Falta el resultado</span>
                <span class="mc-espacio"></span>
                <!-- La línea de tiempo NO se corrige ni se borra: es el
                     historial del monitoreo. Sólo se pueden completar los
                     cortes que nunca tuvieron resultado. -->
                <button type="button" class="mc-btn-sec mini"
                        *ngIf="puedeEditar && (enEdicion(a) && esPendiente(s.resultado))"
                        (click)="editarCorte(a, s)">Capturar resultado</button>
              </div>
              <div class="mc-corte-txt">{{ s.resultado }}</div>
            </div>

            <!-- ----- Corrección en el mismo renglón ----- -->
            <div class="mc-corte-cuerpo" *ngIf="editandoCorte(s)">
              <div class="mc-corte-form">
                <!-- La fecha no se edita: es el dato de registro del corte. -->
                <span class="mc-fecha-fija" title="La fecha del corte no se modifica una vez registrado">
                  {{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}
                </span>
                <input class="i" placeholder="Qué se encontró en este corte" aria-label="Qué se encontró en este corte"
                       [maxlength]="lim.corte.resultado" [(ngModel)]="borradorCorte(s).resultado" />
                <button *ngIf="puedeEditar" type="button" class="mc-btn-pri" (click)="guardarEdicionCorte(a, s)"
                        [disabled]="guardandoEdicionCorte.has(s.idMatrizSeguimiento!)">
                  {{ guardandoEdicionCorte.has(s.idMatrizSeguimiento!) ? 'Guardando…' : 'Guardar' }}
                </button>
                <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="cancelarEdicionCorte(s)"
                        [disabled]="guardandoEdicionCorte.has(s.idMatrizSeguimiento!)">
                  Cancelar
                </button>
              </div>
              <div class="mc-corte-ayuda">
                Solo se corrige el texto del resultado. La fecha del corte y quién lo
                capturó quedan como se registraron.
              </div>
            </div>
          </div>

          <div class="mc-vacio-mini" *ngIf="!a.seguimientos || a.seguimientos.length === 0">
            Sin cortes registrados.
          </div>
        </div>
      </div>

      <!-- ===== Evidencias adjuntas ===== -->
      <!-- Marcadas como "No aplica": solo una línea discreta, reversible. -->
      <div class="mc-evidencias na" *ngIf="expandido(a) && evidenciaAplica[a.idMatrizActivo!] === 'NO'">
        <span class="mc-evd-na">
          Evidencias: <b>No aplica</b> para este activo
        </span>
        <button *ngIf="puedeEditar" type="button" class="mc-btn-sec mini" (click)="marcarSiAplicaEvidencias(a)">
          Cambiar a Sí aplica
        </button>
      </div>

      <div class="mc-evidencias" *ngIf="expandido(a) && evidenciaAplica[a.idMatrizActivo!] !== 'NO'">
        <button type="button" class="mc-toggle" (click)="alternarEvidencias(a)">
          <span class="mc-caret">{{ evidenciasAbiertas.has(a.idMatrizActivo!) ? '▾' : '▸' }}</span>
          Evidencias
          <span class="mc-n">Imagen, PDF, Excel… del tratamiento del riesgo</span>
          <span class="mc-pill" *ngIf="evidencias[a.idMatrizActivo!]?.length">
            {{ evidencias[a.idMatrizActivo!].length }} archivo(s)
          </span>
        </button>

        <div class="mc-evd-cuerpo" *ngIf="evidenciasAbiertas.has(a.idMatrizActivo!)">
          <div class="mc-vacio-mini" *ngIf="cargandoEvidencias.has(a.idMatrizActivo!)">Consultando…</div>

          <ng-container *ngIf="!cargandoEvidencias.has(a.idMatrizActivo!)">
            <div class="mc-evd" *ngFor="let evd of evidencias[a.idMatrizActivo!]">
              <span class="mc-evd-ico">{{ iconoEvidencia(evd) }}</span>
              <div class="mc-evd-txt">
                <span class="mc-evd-nombre">{{ evd.nombreArchivo }}</span>
                <span class="mc-evd-meta">
                  {{ tamanoLegible(evd.tamanioBytes) }} · {{ evd.fechaCarga | fechaBitacora }}
                  <ng-container *ngIf="evd.usuarioNombre">· {{ evd.usuarioNombre }}</ng-container>
                </span>
              </div>
              <span class="mc-espacio"></span>
              <button type="button" class="mc-btn-sec mini" (click)="verEvidencia(evd)">Ver</button>
              <button type="button" class="mc-btn-sec mini" (click)="guardarEvidencia(evd)">Descargar</button>
              <button *ngIf="puedeEditar" type="button" class="mc-btn-rojo mini" (click)="eliminarEvidencia(a, evd)">Eliminar</button>
            </div>

            <div class="mc-vacio-mini"
                 *ngIf="!evidencias[a.idMatrizActivo!] || evidencias[a.idMatrizActivo!].length === 0">
              Sin evidencias adjuntas. Lo que se suba aquí aparece también en el Expediente.
            </div>

            <div class="mc-evd-pie">
              <label class="mc-evd-subir" *ngIf="puedeEditar">
                <input type="file" hidden
                       accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.zip,.mp4,.msg,.eml"
                       (change)="subirEvidencia(a, $event)"
                       [disabled]="subiendoEvidencia.has(a.idMatrizActivo!)">
                <span class="mc-btn-sec mini">
                  {{ subiendoEvidencia.has(a.idMatrizActivo!) ? 'Subiendo…' : '+ Subir evidencia' }}
                </span>
              </label>
              <!-- Solo sin archivos: "no aplica" nunca esconde evidencia existente. -->
              <button type="button" class="mc-evd-btn-na"
                      *ngIf="puedeEditar && (!evidencias[a.idMatrizActivo!] || evidencias[a.idMatrizActivo!].length === 0)"
                      (click)="marcarNoAplicaEvidencias(a)">
                Marcar como No aplica
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ===== Copias de seguridad ===== -->
      <div class="mc-bitacora" *ngIf="expandido(a)">
        <button type="button" class="mc-toggle" (click)="alternarRespaldos(a)">
          <span class="mc-caret">{{ respaldosAbiertos.has(a.idMatrizActivo!) ? '▾' : '▸' }}</span>
          Copias de seguridad
          <span class="mc-n">Versiones anteriores, para regresar</span>
        </button>

        <div class="mc-bit-cuerpo" *ngIf="respaldosAbiertos.has(a.idMatrizActivo!)">
          <div class="mc-vacio-mini" *ngIf="cargandoRespaldos.has(a.idMatrizActivo!)">
            Consultando…
          </div>

          <ng-container *ngIf="!cargandoRespaldos.has(a.idMatrizActivo!)">
            <div class="mc-vacio-mini"
                 *ngIf="!respaldos[a.idMatrizActivo!] || respaldos[a.idMatrizActivo!].length === 0">
              Todavía no hay copias. Se guarda una sola cada vez que el activo cambia o se elimina.
            </div>

            <div class="mc-bit mc-resp" *ngFor="let r of respaldos[a.idMatrizActivo!]">
              <div class="mc-bit-cuerpo-txt">
                <div class="mc-bit-cab">
                  <strong>{{ motivoRespaldo(r) }}</strong>
                  <span class="mc-bit-quien" *ngIf="r.usuarioNombre">{{ r.usuarioNombre }}</span>
                  <span class="mc-bit-quien sin" *ngIf="!r.usuarioNombre">Sistema</span>
                  <span class="mc-bit-fecha">{{ r.fecha | fechaBitacora }}</span>
                </div>
                <div class="mc-bit-valores" *ngIf="r.resumen">
                  <span class="mc-bit-antes">{{ r.resumen }}</span>
                </div>
              </div>
              <div class="mc-resp-botones" *ngIf="puedeEditar">
                <button type="button" class="mc-btn-sec mini"
                        (click)="abrirComparacion(a, r)">
                  Comparar
                </button>
                <button type="button" class="mc-btn-sec mini"
                        (click)="restaurarRespaldo(a, r)"
                        [disabled]="restaurando.has(a.idMatrizActivo!)">
                  {{ restaurando.has(a.idMatrizActivo!) ? 'Restaurando…' : 'Regresar a esta' }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ===== Bitácora ===== -->
      <div class="mc-bitacora" *ngIf="expandido(a)">
        <button type="button" class="mc-toggle" (click)="alternarBitacora(a)">
          <span class="mc-caret">{{ bitacoraAbierta.has(a.idMatrizActivo!) ? '▾' : '▸' }}</span>
          Bitácora de cambios
          <span class="mc-n">Quién cambió qué y cuándo</span>
        </button>

        <div class="mc-bit-cuerpo" *ngIf="bitacoraAbierta.has(a.idMatrizActivo!)">
          <div class="mc-vacio-mini" *ngIf="cargandoBitacora.has(a.idMatrizActivo!)">
            Consultando…
          </div>

          <ng-container *ngIf="!cargandoBitacora.has(a.idMatrizActivo!)">
            <div class="mc-vacio-mini"
                 *ngIf="!bitacora[a.idMatrizActivo!] || bitacora[a.idMatrizActivo!].length === 0">
              Sin movimientos registrados.
            </div>

            <div class="mc-bit" *ngFor="let h of bitacora[a.idMatrizActivo!]">
              <span class="mc-bit-accion" [ngClass]="claseAccion(h.accion)">{{ h.accion }}</span>
              <div class="mc-bit-cuerpo-txt">
                <div class="mc-bit-cab">
                  <strong *ngIf="campo(h)">{{ campo(h) }}</strong>
                  <span class="mc-bit-quien" *ngIf="h.usuarioNombre">{{ h.usuarioNombre }}</span>
                  <span class="mc-bit-quien sin" *ngIf="!h.usuarioNombre">{{ quien(h) }}</span>
                  <span class="mc-bit-fecha">{{ h.fechaCambio | fechaBitacora }}</span>
                </div>
                <div class="mc-bit-valores" *ngIf="h.valorAnterior || h.valorNuevo">
                  <span class="mc-bit-antes" *ngIf="h.valorAnterior">{{ h.valorAnterior }}</span>
                  <span class="mc-bit-flecha" *ngIf="h.valorAnterior && h.valorNuevo">&rarr;</span>
                  <span class="mc-bit-nuevo" *ngIf="h.valorNuevo">{{ h.valorNuevo }}</span>
                </div>
              </div>
              <!-- Desde la propia bitácora se vuelve a cualquier versión: el
                   renglón dice qué pasó y este botón lo deshace. Sólo aparece
                   si de ese movimiento se guardó copia. -->
              <button type="button" class="mc-btn-sec mini"
                      *ngIf="puedeEditar && h.idRespaldo"
                      (click)="restaurarDesdeBitacora(a, h)"
                      [disabled]="restaurando.has(a.idMatrizActivo!)"
                      matTooltip="Regresa el activo a como estaba justo antes de este movimiento.">
                {{ restaurando.has(a.idMatrizActivo!) ? 'Restaurando…' : 'Regresar a antes' }}
              </button>
            </div>
          </ng-container>
        </div>
      </div>

    </div>

   </div>
  </ng-container>

  <!-- ==================== Vista previa formato FOS-005 ==================== -->
  <ng-container *ngIf="vistaPrevia">

    <div class="mc-barra">
      <div>
        <strong>Formato FOS-005 — vista previa</strong>
        <span class="mc-hint">
          Así se ve la hoja «Activos» en el Excel oficial. Solo lectura:
          para editar, cierra esta vista y usa las tarjetas.
        </span>
      </div>
      <div class="mc-acciones">
        <button type="button" class="mc-btn-cerrar" (click)="alternarVista()">✕ Cerrar</button>
      </div>
    </div>

    <div class="mc-scroll">
      <table class="mc-tabla">
      <!--
      Los anchos van aquí y no al criterio del navegador: sin esto, las
      columnas de texto se aplastan al mínimo y parten una palabra por
      renglón, que era lo que hacía que un activo midiera media pantalla.
      -->
      <colgroup>
      <col class="w-no" />
      <col class="w-nombre" />
      <col class="w-tipo" />
      <col class="w-cid" /><col class="w-cid" /><col class="w-cid" />
      <col class="w-valor" />
      <col class="w-texto" />
      <col class="w-texto" />
      <col class="w-prob" /><col class="w-prob" />
      <col class="w-num" /><col class="w-num" />
      <col class="w-texto" />
      <col class="w-prob" /><col class="w-prob" />
      <col class="w-num" /><col class="w-num" />
      <col class="w-riesgo" /><col class="w-riesgo" />
      <col class="w-fecha" />
      <col class="w-texto" />
      <col class="w-estado" />
      <col class="w-persona" />
      <col class="w-prioridad" />
      <col class="w-persona" />
      <col class="w-fecha" />
      <!-- Seguimiento del Riesgo, las dos ultimas del formato -->
      <col class="w-fecha" />
      <col class="w-texto" />
      </colgroup>

      <thead>
      <!--
      Los title son las notas que en el Excel salian al pasar el mouse.
      Donde el encabezado del Excel decia una cosa y la columna guardaba
      otra, manda el dato y el nombre original queda en la nota.
      -->
      <tr>
      <th rowspan="2" class="fija-1">No</th>
      <th rowspan="2" class="fija-2">Nombre del Activo</th>
      <th rowspan="2">Tipo de activo</th>
      <th colspan="4" class="c nota" [title]="notas['valoracionActivo']">
      Valoración del Activo <span class="th-esc">(1 a 5)</span>
      </th>
      <th rowspan="2">Activos Dependientes</th>
      <th rowspan="2" class="nota" [title]="notas['nombreAmenaza']">Nombre amenaza</th>
      <th colspan="2" class="c nota" [title]="notas['probAmenaza']">Probabilidad de la amenaza</th>
      <th colspan="2" class="c nota"
      title="El más alto de los niveles de probabilidad de sus amenazas. No es un conteo: un activo con dos amenazas puede tener nivel 3. En el FOS-005 esta columna se llama «Total amenazas».">
      Nivel de amenaza <span class="th-esc">(el más alto)</span>
      </th>
      <th rowspan="2" class="nota" [title]="notas['vulnerabilidad']">Vulnerabilidad</th>
      <th colspan="2" class="c nota" [title]="notas['probVulnerabilidad']">Probabilidad de la vulnerabilidad</th>
      <th colspan="2" class="c nota"
      title="El más alto de los niveles de probabilidad de sus vulnerabilidades. No es un conteo. En el FOS-005 esta columna se llama «Total vulnerab.».">
      Nivel de vulnerabilidad <span class="th-esc">(el más alto)</span>
      </th>
      <th colspan="2" class="c nota" [title]="notas['nivelRiesgoActivo']">
      Nivel del Riesgo <span class="th-esc">(0 a 11)</span>
      </th>
      <th rowspan="2" class="nota" [title]="notas['fechaIdentificacion']">Fecha de<br>Identificación</th>
      <th colspan="6" class="c">Plan de Acción</th>
      <th colspan="2" class="c nota"
      title="Lo mismo que en el FOS-005: cuándo se comprobó por última vez y qué se encontró. Aplica a los activos de riesgo Alto y Muy Alto.">
      Seguimiento del Riesgo <span class="th-esc">(riesgo Alto y Muy Alto)</span>
      </th>
      </tr>
      <tr>
      <th scope="col" class="c mini nota" [title]="notas['confidencialidad']">
      C<span class="th-sub">Confid.</span>
      </th>
      <th scope="col" class="c mini nota" [title]="notas['integridad']">
      I<span class="th-sub">Integr.</span>
      </th>
      <th scope="col" class="c mini nota" [title]="notas['disponibilidad']">
      D<span class="th-sub">Dispon.</span>
      </th>
      <th scope="col" class="c mini" title="El más alto de los tres: confidencialidad, integridad y disponibilidad.">Valor</th>
      <th scope="col" class="c mini">Actual</th>
      <th scope="col" class="c mini proy" title="Probabilidad estimada una vez ejecutado el plan de acción.">Tras el plan</th>
      <th scope="col" class="c mini">Actual</th>
      <th scope="col" class="c mini proy" title="Nivel estimado una vez ejecutado el plan de acción.">Tras el plan</th>
      <th scope="col" class="c mini">Actual</th>
      <th scope="col" class="c mini proy" title="Probabilidad estimada una vez ejecutado el plan de acción.">Tras el plan</th>
      <th scope="col" class="c mini">Actual</th>
      <th scope="col" class="c mini proy" title="Nivel estimado una vez ejecutado el plan de acción.">Tras el plan</th>
      <th scope="col" class="c mini">Actual</th>
      <th scope="col" class="c mini proy" title="El riesgo que queda una vez ejecutado el plan de acción.">Residual</th>
      <th scope="col">Acciones</th>
      <th scope="col" class="mini">Estado</th>
      <th scope="col">Responsable</th>
      <th scope="col" class="mini nota" [title]="notas['prioridad']">Prioridad</th>
      <th scope="col" class="nota" [title]="notas['recursos']">Recursos</th>
      <th scope="col" class="mini">Fecha ejec.</th>
      <th scope="col" class="mini">Última Fecha<br>de Monitoreo</th>
      <th scope="col">Resultado</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let f of filas" [class.inicio-activo]="f.primeraDelActivo">

      <!-- ===== Datos del activo (una sola vez por bloque) ===== -->
      <ng-container *ngIf="f.primeraDelActivo">
      <td [attr.rowspan]="f.spanActivo" class="c nw fija-1">
      <strong>{{ f.activo.consecutivo }}</strong>



      </td>

      <td [attr.rowspan]="f.spanActivo" class="fija-2">
      <span>{{ f.activo.nombreActivo }}</span>

      <div class="mc-folio" *ngIf="f.activo.inventarioConsecutivo">
      {{ f.activo.inventarioConsecutivo }}
      </div>
      </td>

      <td [attr.rowspan]="f.spanActivo">
      <span>{{ f.activo.tipoActivo }}</span>

      </td>

      <td [attr.rowspan]="f.spanActivo" class="c">
      <span>{{ f.activo.valConfidencialidad }}</span>

      </td>
      <td [attr.rowspan]="f.spanActivo" class="c">
      <span>{{ f.activo.valIntegridad }}</span>

      </td>
      <td [attr.rowspan]="f.spanActivo" class="c">
      <span>{{ f.activo.valDisponibilidad }}</span>

      </td>
      <td [attr.rowspan]="f.spanActivo" class="c calc">
      <strong>{{ f.activo.valorActivo }}</strong>
      </td>

      <td [attr.rowspan]="f.spanActivo">
      <span>{{ f.activo.activosDependientes }}</span>

      </td>
      </ng-container>

      <!-- ===== Amenaza ===== -->
      <ng-container *ngIf="f.primeraDeAmenaza">
      <td [attr.rowspan]="f.spanAmenaza">
      <ng-container *ngIf="f.amenaza">
      <span>{{ f.amenaza.nombreAmenaza }}</span>


      </ng-container>
      <span class="vacia" *ngIf="!f.amenaza">—</span>
      </td>

      <td [attr.rowspan]="f.spanAmenaza" class="c">
      <ng-container *ngIf="f.amenaza">
      <span>{{ etiquetaProb('AMENAZA', f.amenaza.probActual) }}</span>

      </ng-container>
      </td>
      <td [attr.rowspan]="f.spanAmenaza" class="c proy">
      <ng-container *ngIf="f.amenaza">
      <span>{{ etiquetaProb('AMENAZA', f.amenaza.probTrasPlan) }}</span>

      </ng-container>
      </td>
      </ng-container>

      <!-- Totales de amenaza: son del activo, calculados por el backend -->
      <ng-container *ngIf="f.primeraDelActivo">
      <td [attr.rowspan]="f.spanActivo" class="c calc">{{ f.activo.nivelAmenaza }}</td>
      <td [attr.rowspan]="f.spanActivo" class="c calc proy">{{ f.activo.nivelAmenazaTrasPlan }}</td>
      </ng-container>

      <!-- ===== Vulnerabilidad ===== -->
      <ng-container *ngIf="f.primeraDeVulnerabilidad">
      <td [attr.rowspan]="f.spanVulnerabilidad">
      <ng-container *ngIf="f.vulnerabilidad">
      <span>{{ f.vulnerabilidad.nombreVulnerabilidad }}</span>
      </ng-container>
      <span class="vacia" *ngIf="!f.vulnerabilidad">—</span>
      </td>

      <td [attr.rowspan]="f.spanVulnerabilidad" class="c">
      <ng-container *ngIf="f.vulnerabilidad">
      <span>{{ etiquetaProb('VULNERABILIDAD', f.vulnerabilidad.probActual) }}</span>

      </ng-container>
      </td>
      <td [attr.rowspan]="f.spanVulnerabilidad" class="c proy">
      <ng-container *ngIf="f.vulnerabilidad">
      <span>{{ etiquetaProb('VULNERABILIDAD', f.vulnerabilidad.probTrasPlan) }}</span>

      </ng-container>
      </td>
      </ng-container>

      <!-- Totales de vulnerabilidad y riesgo: del activo -->
      <ng-container *ngIf="f.primeraDelActivo">
      <td [attr.rowspan]="f.spanActivo" class="c calc">{{ f.activo.nivelVulnerabilidad }}</td>
      <td [attr.rowspan]="f.spanActivo" class="c calc proy">{{ f.activo.nivelVulnerabilidadTrasPlan }}</td>

      <!-- El número solo no dice nada: 9 de 11 es Alto, y eso es lo que
      define cada cuándo hay que comprobarlo. -->
      <td [attr.rowspan]="f.spanActivo" class="c">
      <!-- title nativo y no matTooltip: el tooltip de Material se dibuja en el
           overlay del CDK, que queda debajo de esta vista a pantalla completa. -->
      <span class="chip" [ngClass]="claseRiesgo(f.activo.clasificacionActual)"
      [title]="'Comprobación ' + (f.activo.periodicidadMaxima || 'no definida')">
      {{ f.activo.riesgoActual }}
      </span>
      <div class="mc-clas">{{ f.activo.clasificacionActual }}</div>
      </td>
      <td [attr.rowspan]="f.spanActivo" class="c proy">
      <span class="chip" [ngClass]="claseRiesgo(f.activo.clasificacionResidual)">
      {{ f.activo.riesgoResidual }}
      </span>
      <div class="mc-clas">{{ f.activo.clasificacionResidual }}</div>
      </td>

      <td [attr.rowspan]="f.spanActivo" class="c nw">
      <span>{{ f.activo.fechaIdentificacion | date: 'dd/MM/yyyy' }}</span>

      </td>
      </ng-container>

      <!-- ===== Plan de acción ===== -->
      <td>
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.descripcion }}</span>

      </ng-container>
      <span class="vacia" *ngIf="!f.accion">—</span>
      </td>
      <td class="c">
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.estado }}</span>

      </ng-container>
      </td>
      <td>
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.responsable }}</span>

      </ng-container>
      </td>
      <td class="c">
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.prioridad }}</span>

      </ng-container>
      </td>
      <td>
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.recursos }}</span>

      </ng-container>
      </td>
      <td class="c nw">
      <ng-container *ngIf="f.accion">
      <span>{{ f.accion.fechaEjecucion | date: 'dd/MM/yyyy' }}</span>
      </ng-container>

      </td>

      <!-- ===== Seguimiento del Riesgo ===== -->
      <!-- La fecha va combinada por activo, como en el formato: es el corte
           del bloque. El resultado sí es por renglón, porque cada acción
           reporta el suyo. -->
      <ng-container *ngIf="f.primeraDelActivo">
      <td [attr.rowspan]="f.spanActivo" class="c nw">
      <span *ngIf="ultimaFechaMonitoreo(f.activo) as fm">{{ fm | date: 'dd/MM/yyyy' }}</span>
      <span class="vacia" *ngIf="!ultimaFechaMonitoreo(f.activo)">—</span>
      </td>
      </ng-container>
      <td>
      <span *ngIf="f.corte">{{ f.corte.resultado }}</span>
      <span class="vacia" *ngIf="!f.corte">—</span>
      </td>

      </tr>
      </tbody>
      </table>
    </div>

  </ng-container>

  <!-- ==================== Expediente del activo ====================
       Evidencia de trazabilidad: inventario, monitoreos, incidencias y
       riesgos de proceso del activo, en una ventana de solo lectura.
       El componente se cuelga solo de <body>. -->
  <app-expediente-activo-ia *ngIf="expediente" [activo]="expediente"
                            (cerrar)="cerrarExpediente()"></app-expediente-activo-ia>

  <!-- ==================== Comparar versiones ====================
       Una copia enfrentada contra el activo de hoy. Sólo lectura: se cierra
       con Escape, con el botón o pulsando el fondo, que aquí no cuesta nada
       porque no hay nada capturado que perder. -->
  <div class="mc-cmp-fondo" *ngIf="comparaActivo" (click)="cerrarComparacion()" (keydown.enter)="cerrarComparacion()">
    <div class="mc-cmp" role="dialog" aria-modal="true"
         aria-label="Comparación de versiones" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">

      <div class="mc-cmp-cab">
        <div class="mc-cmp-cab-txt">
          <strong>Comparar versiones</strong>
          <span class="mc-cmp-sub" *ngIf="comparacion">
            {{ comparacion.referencia }} · {{ comparacion.titulo }}
          </span>
        </div>
        <button type="button" class="mc-cmp-cerrar" (click)="cerrarComparacion()">✕ Cerrar</button>
      </div>

      <!-- Qué se está enfrentando contra qué. -->
      <div class="mc-cmp-lados">
        <div class="mc-cmp-lado">
          <span class="mc-cmp-lado-et">Versión anterior</span>
          <!-- ngModel de una via y no [value]: el binding del <select> se evalua
               ANTES de que el *ngFor cree sus <option>, y la seleccion se perdia. -->
          <select class="mc-cmp-select" aria-label="Versión anterior" *ngIf="comparaVersiones.length > 1"
                  [disabled]="comparando"
                  [ngModel]="comparaIdRespaldo"
                  (ngModelChange)="comparaOtraVersion($event)">
            <option *ngFor="let v of comparaVersiones" [ngValue]="v.idRespaldo">
              {{ v.fecha | fechaBitacora }} · {{ motivoRespaldo(v) }}{{ v.usuarioNombre ? ' · ' + v.usuarioNombre : '' }}
            </option>
          </select>
          <span class="mc-cmp-lado-val" *ngIf="comparaVersiones.length <= 1 && comparacion">
            {{ comparacion.etiquetaAntes }}
          </span>
        </div>
        <span class="mc-cmp-vs">contra</span>
        <div class="mc-cmp-lado">
          <span class="mc-cmp-lado-et">Versión actual</span>
          <span class="mc-cmp-lado-val" *ngIf="comparacion">{{ comparacion.etiquetaDespues }}</span>
        </div>
      </div>

      <div class="mc-cmp-cuerpo">
        <div class="mc-vacio-mini" *ngIf="comparando">Comparando…</div>

        <ng-container *ngIf="!comparando && comparacion">
          <!-- El aviso de que el registro ya no existe va arriba: cambia cómo
               se lee todo lo que sigue. -->
          <div class="mc-cmp-aviso" *ngIf="!comparacion.existeActual">
            Este activo ya no existe en la matriz: se eliminó y no se ha restaurado.
            Lo que sigue es todo lo que traía la copia.
          </div>

          <div class="mc-cmp-marcador">
            <span class="mc-cmp-tot cmp-alta" *ngIf="comparacion.agregados">
              {{ comparacion.agregados }} nuevo{{ comparacion.agregados === 1 ? '' : 's' }}
            </span>
            <span class="mc-cmp-tot cmp-baja" *ngIf="comparacion.eliminados">
              {{ comparacion.eliminados }} quitado{{ comparacion.eliminados === 1 ? '' : 's' }}
            </span>
            <!-- "campos" a proposito: los de arriba cuentan bloques enteros
                 (una amenaza que nace o se va) y este cuenta campos sueltos.
                 Sin decirlo, los tres numeros parecian de la misma cosa. -->
            <span class="mc-cmp-tot cmp-cambio" *ngIf="comparacion.cambiados">
              {{ comparacion.cambiados }} campo{{ comparacion.cambiados === 1 ? '' : 's' }} cambiado{{ comparacion.cambiados === 1 ? '' : 's' }}
            </span>
            <span class="mc-cmp-tot cmp-igual" *ngIf="comparacion.sinCambios">
              Sin diferencias: la copia y la versión de hoy son iguales
            </span>
            <button type="button" class="mc-cmp-filtro" (click)="alternarSoloCambios()">
              {{ comparaSoloCambios ? 'Ver también lo que no cambió' : 'Ver sólo lo que cambió' }}
            </button>
          </div>

          <div class="mc-cmp-grupo" *ngFor="let v of comparaVista"
               [ngClass]="'n' + v.grupo.nivel">
            <div class="mc-cmp-grupo-cab">
              <span class="mc-cmp-marca" [ngClass]="claseComparacion(v.grupo.estado)">
                {{ etiquetaComparacion(v.grupo.estado) }}
              </span>
              <strong>{{ v.grupo.titulo }}</strong>
              <span class="mc-cmp-ctx" *ngIf="v.grupo.contexto">{{ v.grupo.contexto }}</span>
            </div>

            <div class="mc-cmp-renglon" *ngFor="let r of v.renglones"
                 [ngClass]="claseRenglonComparacion(r.estado)">
              <span class="mc-cmp-campo">
                {{ r.etiqueta }}
                <span class="mc-cmp-calc" *ngIf="r.calculado" matTooltip="Sale de una fórmula: cambia porque cambiaron sus insumos">ƒ</span>
              </span>
              <span class="mc-cmp-valores">
                <span class="mc-cmp-antes" *ngIf="r.antes">{{ r.antes }}</span>
                <span class="mc-cmp-nada" *ngIf="!r.antes">—</span>
                <span class="mc-cmp-flecha">&rarr;</span>
                <span class="mc-cmp-despues" *ngIf="r.despues">{{ r.despues }}</span>
                <span class="mc-cmp-nada" *ngIf="!r.despues">—</span>
              </span>
            </div>

            <div class="mc-vacio-mini" *ngIf="v.renglones.length === 0">
              Sin cambios en este bloque.
            </div>
          </div>

          <div class="mc-cmp-pie" *ngIf="comparaOcultos > 0 && comparaSoloCambios">
            Se ocultaron {{ comparaOcultos }} bloque{{ comparaOcultos === 1 ? '' : 's' }} sin cambios.
          </div>
        </ng-container>
      </div>
    </div>
  </div>

</div>
